module.exports = "fonts/poppins-v9-latin-800.woff2";